module.exports = __webpack_public_path__ + "img/sign_before.bf06bf3e.png";